import React, { useEffect, useRef, useState } from "react";

import styles from "./NotificationBanner.module.css";

export const NotificationBanner = ({
  errorMessage,
  setShowBanner,
  showBanner,
}: {
  errorMessage: string;
  setShowBanner: (input: string | null) => void;
  showBanner: null | string;
}) => {
  const timerIdRef = useRef<NodeJS.Timeout | null>(null);
  const [width, setWidth] = useState<number>(0);

  useEffect(() => {
    if (showBanner && !timerIdRef.current) {
      timerIdRef.current = setInterval(() => {
        setWidth((p) => p + 2);
      }, 100);
    }
  }, [showBanner]);

  useEffect(() => {
    if (width >= 99) {
      timerIdRef.current && clearInterval(timerIdRef.current);
      setShowBanner(null);
    }
  }, [setShowBanner, width]);

  return (
    <div className={styles.container}>
      {`Error: ${errorMessage}`}
      {/* NotificationBanner */}
      <div
        className={styles.cross}
        onClick={() => {
          timerIdRef.current && clearInterval(timerIdRef.current);
          setShowBanner(null);
        }}
      >
        x
      </div>
      <div className={styles.stripe} style={{ width: `${width}%` }}></div>
    </div>
  );
};

export default NotificationBanner;
